<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="OT">Contents</p>
<p class="CON1" id="toc1"><a href="#/Gonzalez_The_Story_Luke_Tells_text_CC3#_idTOCAnchor-1">Introduction</a></p>
<p class="CON2" id="toc2"><a href="#/Gonzalez_The_Story_Luke_Tells_text_CC4#_idTOCAnchor-2">1. Luke and the History of Humankind</a></p>
<p class="CON2" id="toc3"><a href="#/Gonzalez_The_Story_Luke_Tells_text_CC5#_idTOCAnchor-3">2. Luke and the History of Israel</a></p>
<p class="CON2" id="toc4"><a href="#/Gonzalez_The_Story_Luke_Tells_text_CC6#_idTOCAnchor-4">3. Luke and the Great Reversal</a></p>
<p class="CON2" id="toc5"><a href="#/Gonzalez_The_Story_Luke_Tells_text_CC7#_idTOCAnchor-5">4. Luke and Gender</a></p>
<p class="CON2" id="toc6"><a href="#/Gonzalez_The_Story_Luke_Tells_text_CC8#_idTOCAnchor-6">5. Luke and Salvation</a></p>
<p class="CON2" id="toc7"><a href="#/Gonzalez_The_Story_Luke_Tells_text_CC9#_idTOCAnchor-7">6. Food and Drink in Luke’s Theology</a></p>
<p class="CON2" id="toc8"><a href="#/Gonzalez_The_Story_Luke_Tells_text_CC10#_idTOCAnchor-8">7. Luke and Worship</a></p>
<p class="CON2" id="toc9"><a href="#/Gonzalez_The_Story_Luke_Tells_text_CC11#_idTOCAnchor-9">8. Luke and the Holy Spirit</a></p>
<p class="CON2" id="toc10"><a href="#/Gonzalez_The_Story_Luke_Tells_text_CC12#_idTOCAnchor-10">Conclusion: Luke’s Open Invitation</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Gonzalez_The_Story_Luke_Tells_text_CC-1.vue?f1441c8e